module.exports = __webpack_public_path__ + "public/images/reading.bf22576e3ef236ae590a7bedcb5dab81.jpg";